import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { LocationStrategy, HashLocationStrategy} from '@angular/common';
import { HttpClientModule } from '@angular/common/http';


import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/layout.component';
import { SharedModule } from './shared/shared.module';
import { BreadcrumbsComponent } from './layouts/breadcrumbs/breadcrumbs.component';
import { TitleComponent } from './layouts/title/title.component';
import { LoginComponent } from './authentication/login/login.component';
import { ChangePasswordComponent } from './authentication/change-password/change-password.component';
import { SettingService } from './nucleo/configuracion/setting.service';
import { FooterComponent } from './layouts/footer/footer.component';
import { EnvServiceProvider } from './nucleo/configuracion/environment.service.provider';
import { routing } from './routing/app.routing';
import { AuthorizationGuard } from './nucleo/guards/auth-guard';
import { AuthApiService } from './seguridad/auth-api.service';
import { AutenticacionService } from './seguridad/autenticacion.service';
import { CompareValidatorDirective } from './nucleo/directiva/compare-validator.directive';
import { NotFoundComponent } from './authentication/not-found/not-found.component';
import { NotAuthorizedComponent } from './authentication/not-authorized/not-authorized.component';
import { SessionExpiredComponent } from './authentication/session-expired/session-expired.component';

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    BreadcrumbsComponent,
    TitleComponent,
    LoginComponent,
    ChangePasswordComponent,
    FooterComponent,
    CompareValidatorDirective,
    NotFoundComponent,
    NotAuthorizedComponent,
    SessionExpiredComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    routing
  ],
  providers: [
      { provide: LocationStrategy, useClass: HashLocationStrategy  },
      SettingService,
      EnvServiceProvider,
      AuthorizationGuard,
      AuthApiService,
      AutenticacionService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
